// Phản hồi nhặt đồ (ITEMS §9, UI_SPEC §12 bậc ②): món bay theo đường cong vào nút Túi ở rail, nút nảy;
// cột sáng Pixi + chuông theo phẩm. Chỉ khi online (loot offline đọc ở Hồi Sơn).
import type { JSX } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { RARITIES } from '@data/items/types';
import { consumeLootFx, lootFx } from '@state/modules/inventory';
import { settings } from '@state/modules/settings';
import { bell } from '../audio';
import { rarityClass } from '../itemView';

let beamHook: ((lv: number) => void) | null = null;
/** main.ts nối cột sáng Pixi. */
export function setBeamHook(fn: (lv: number) => void): void {
  beamHook = fn;
}

/** Tối đa 4 chấm bay mỗi đợt; nhịp lệch giữa hai chấm trong CÙNG đợt. */
const FLIES_PER_BATCH = 4;
const FLY_STAGGER_MS = 60;
const FLY_MS = 620;
/** Trần số chấm còn trên màn (đợt dồn liên tục không làm DOM phình). */
const FLIES_MAX = 12;

interface Fly {
  seq: number;
  lv: number;
  delayMs: number;
}

export function LootFxHost(): JSX.Element {
  const [flies, setFlies] = useState<Fly[]>([]);
  // Hẹn giờ gỡ chấm sống ngoài cleanup của effect đợt (effect chạy lại ngay khi consumeLootFx đổi
  // hàng đợi); chỉ hủy khi gỡ host.
  const timers = useRef(new Set<ReturnType<typeof setTimeout>>());
  const queue = lootFx.value;
  useEffect(
    () => () => {
      for (const id of timers.current) clearTimeout(id);
      timers.current.clear();
    },
    [],
  );
  useEffect(() => {
    if (!queue.length) return;
    const last = queue[queue.length - 1]!.seq;
    // Gộp một đợt: chỉ phẩm cao nhất có cột + chuông; mỗi món một chấm bay (tối đa 4).
    const top = Math.max(...queue.map((f) => RARITIES.indexOf(f.rarity)));
    beamHook?.(top);
    bell(top);
    const rm = settings.peek().reduceMotion;
    const add = queue.slice(-FLIES_PER_BATCH).map((f, i) => ({
      seq: f.seq,
      lv: RARITIES.indexOf(f.rarity),
      delayMs: rm ? 0 : i * FLY_STAGGER_MS,
    }));
    setFlies((xs) => [...xs, ...add].slice(-FLIES_MAX));
    consumeLootFx(last);
    const gone = new Set(add.map((f) => f.seq));
    const ms = rm ? 10 : FLY_MS + (add.length - 1) * FLY_STAGGER_MS;
    const id = setTimeout(() => {
      timers.current.delete(id);
      setFlies((xs) => xs.filter((x) => !gone.has(x.seq)));
    }, ms);
    timers.current.add(id);
  }, [queue]);
  return (
    <div class="loot-fly-layer" aria-hidden="true">
      {flies.map((f) => (
        <i class={`loot-fly ${rarityClass(f.lv)}`} key={f.seq} style={{ animationDelay: `${f.delayMs}ms` }} />
      ))}
    </div>
  );
}
